// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".list-item[data-v-3c137f17] {\n  display: inline-block;\n  margin-right: 10px;\n}\n.list-enter-active[data-v-3c137f17],\n.list-leave-active[data-v-3c137f17] {\n  transition: all 1s;\n}\n.list-enter[data-v-3c137f17], .list-leave-to[data-v-3c137f17] {\n  opacity: 0;\n  transform: translateX(-30px);\n}", ""]);
// Exports
module.exports = exports;
